export const LERWERK_GPT_START = "[LERWERK_GPT] START";
export const LERWERK_GPT_SUCCESS = "[LERWERK_GPT] SUCCESS";
export const LERWERK_GPT_FAILURE = "[LERWERK_GPT] FAILURE";